package org.example.project

import androidx.compose.runtime.*
import org.example.project.ui.GameScreen
import org.example.project.ui.LobbyScreen
import org.example.project.ui.LoginScreen
import org.example.project.ui.SetupScreen

enum class ScreenState { LOGIN, SETUP, LOBBY, GAME }

@Composable
fun App() {
    var currentScreen by remember { mutableStateOf(ScreenState.LOGIN) }
    var playerName by remember { mutableStateOf("Gast") }
    var playerAvatarName by remember { mutableStateOf("avatargreen") } // STRING wie in App
    var playerAvatarIndex by remember { mutableStateOf(0) }            // fuer SP-UI weiterhin Int
    var selectedLangCode by remember { mutableStateOf("DE") }
    var selectedDifficulty by remember { mutableStateOf("easy") }

    // Multiplayer-State
    var roomCode by remember { mutableStateOf("") }
    var isHost by remember { mutableStateOf(false) }

    when (currentScreen) {
        ScreenState.LOGIN -> LoginScreen(onGuestLogin = { langCode ->
            selectedLangCode = langCode
            currentScreen = ScreenState.SETUP
        })

        ScreenState.SETUP -> SetupScreen(
            initialLangCode = selectedLangCode, // Hier wird die Sprache aus dem Login übergeben
            onStartGame = { name, avatarIdx, avatarName, lang, diff, mode ->
                playerName = name
                playerAvatarIndex = avatarIdx
                playerAvatarName = avatarName
                selectedLangCode = lang
                selectedDifficulty = diff
                when (mode) {
                    0 -> {
                        // Single Player
                        roomCode = ""
                        isHost = false
                        currentScreen = ScreenState.GAME
                    }
                    1 -> {
                        // Host: Raum erstellen — direkt ins Spiel,
                        // GameScreen zeigt Code und wartet auf Gast
                        roomCode = ""
                        isHost = true
                        currentScreen = ScreenState.GAME
                    }
                    2 -> {
                        // Gast: Code eingeben in Lobby
                        isHost = false
                        currentScreen = ScreenState.LOBBY
                    }
                }
            }
        )

        ScreenState.LOBBY -> LobbyScreen(
            playerName = playerName,
            playerAvatarName = playerAvatarName,
            langCode = selectedLangCode,
            difficulty = selectedDifficulty,
            onBack = { currentScreen = ScreenState.SETUP },
            onRoomJoined = { code ->
                roomCode = code
                isHost = false
                currentScreen = ScreenState.GAME
            }
        )

        ScreenState.GAME -> GameScreen(
            playerName = playerName,
            playerAvatarIndex = playerAvatarIndex,
            playerAvatarName = playerAvatarName,
            langCode = selectedLangCode,
            difficulty = selectedDifficulty,
            isMultiplayer = (isHost || roomCode.isNotEmpty()),
            roomCode = roomCode,
            isHost = isHost,
            onBack = { currentScreen = ScreenState.SETUP }
        )
    }
}